function readBuildValue(value: string | undefined, fallback: string): string {
  const normalized = value?.trim();
  return normalized ? normalized : fallback;
}

const productName = readBuildValue(import.meta.env.VITE_APP_NAME, "Leylion");

export const BRAND = Object.freeze({
  productName,
  shortName: readBuildValue(import.meta.env.VITE_APP_SHORT_NAME, productName),
  description: readBuildValue(
    import.meta.env.VITE_APP_DESCRIPTION,
    "Unified business operations, point of sale and customer management."
  ),
  supportEmail: readBuildValue(
    import.meta.env.VITE_SUPPORT_EMAIL,
    "support@leylion.com"
  ),
  publicUrl: readBuildValue(
    import.meta.env.VITE_PUBLIC_URL,
    "https://leylion.com"
  ),
  loginEyebrow: `${productName.toUpperCase()} · BUSINESS OPERATING SYSTEM`,
  assets: Object.freeze({
    mark: readBuildValue(import.meta.env.VITE_BRAND_MARK_URL, "/brand/leylion-mark.svg"),
    wordmarkDark: readBuildValue(
      import.meta.env.VITE_BRAND_WORDMARK_DARK_URL,
      "/brand/leylion-wordmark-dark.svg"
    ),
    wordmarkLight: readBuildValue(
      import.meta.env.VITE_BRAND_WORDMARK_LIGHT_URL,
      "/brand/leylion-wordmark-light.svg"
    )
  })
});

export const STORAGE_KEYS = Object.freeze({
  accessToken: "leylion_access_token",
  platformAccessToken: "leylion_platform_access_token",
  selectedContext: "leylion_selected_context",
  permissions: "leylion_permissions",
  permissionRevision: "leylion_permission_revision",
  managerApprovalGate: "leylion_manager_approval_gate"
});

// One-time migration support for browsers that previously ran the application
// under the legacy product name. These values are not displayed to users.
export const LEGACY_STORAGE_KEYS = Object.freeze({
  accessToken: "novexpos_access_token",
  selectedContext: "novexpos_selected_context",
  permissions: "novexpos_permissions",
  permissionRevision: "novexpos_permission_revision",
  managerApprovalGate: "novexpos_manager_approval_gate"
});

export const OFFLINE_QUEUE_EVENT = "leylion-offline-queue-changed";
export const LEGACY_OFFLINE_DATABASE_NAME = "novexpos-offline";
